<template>
  <div class="plots">
        <div class="flex-plot-buffer">
          <Legend title="Buffer" :entries="[
            {name: 'Front buffer', color: '#00ddff'},
            {name: 'Back buffer', color: '#00586f'}]"/>

          <PlotCircularBuffer :ppPlayerRef='ppPlayerRef'/>
        </div>

        <div class="flex-plots">
          <div class="flex-plot-states">
            <Legend title="States" :entries="[
          // {name: 'Idle', color: '#befffa'},
          {name: 'Preparing', color: 'rgba(0,205,255,0.5)'},
          {name: 'Buffering', color: 'rgba(255,181,92,0.5)'},
          {name: 'Playing', color: 'rgba(100,255,114,0.5)'},
          {name: 'Paused', color: 'rgba(255,251,0,0.5)'},
          //{name: 'Ended', color: '#7dfffc'},
          {name: 'Error', color: 'rgba(255,7,5,0.5)'},
        ]"/>
            <PlotState :ppPlayerRef='ppPlayerRef' :xaxis='false' class="border plot state-plot"/>
          </div>
          <div class="flex-plot-renditions">
            <Legend title="Renditions" :entries="[
          {name: 'Playing', color: 'rgb(194, 54, 51)'},
          {name: 'Loading', color: 'rgba(25,127,171,0.5)'},
        ]"/>
            <PlotRenditions :ppPlayerRef='ppPlayerRef' :legend='true' :xaxis='false' class="border plot line-plot"/>
          </div>
          <div class="flex-plot-front-buffer">
            <Legend title="Front Buffer"/>
            <PlayerCardBufferPlot :ppPlayerRef='ppPlayerRef' class="plot line-plot"/>
            <Legend title="Playback history [seconds]" class="legend-centered"/>
          </div>
        </div>
  </div>
</template>

<script>
import Legend from '../Legend';
import PlotCircularBuffer from './info/PlotCircularBuffer';
import PlayerCardBufferPlot from './info/PlotBuffer';
import PlotRenditions from './info/PlotRenditions';
import PlotState from './info/PlotState';

export default {
  name: 'PlayerPlots',
  props: ['ppPlayerRef'],
  components: { PlotState, PlotRenditions, PlayerCardBufferPlot, PlotCircularBuffer, Legend }
};
</script>

<style scoped lang="scss">

  @import "../../style/color_";

  .plots {
    width: 100%;
  }

  .border {
    border-bottom: 1px solid $color-secondary;
    margin-bottom: 4px;
  }

  .plot {
  }

  .line-plot {
    height: 150px;
  }

  .state-plot {
    height: 30px;
  }

  .legend-centered {
    text-align: center;
  }

  .flex-plots {
    width: 100%;
  }
  .plots {
    /*display: flex;*/
  }

  /*@media (min-width: 600px) {*/

  /*  .page-demo-player {*/
  /*    !*display: flex;*!*/
  /*    !*flex-direction: row;*!*/
  /*    !*flex-wrap: wrap;*!*/
  /*    !*justify-content: space-between;*!*/
  /*  }*/

  /*  .flex-plot-buffer {*/
  /*    !*padding-left: 24px;*!*/
  /*    !*padding-right: 24px;*!*/
  /*  }*/
  /*  .flex-plot-buffer, .flex-plot-states, .flex-plot-front-buffer, .flex-plot-renditions {*/
  /*    flex: 1 1 auto;*/
  /*  }*/

  /*  .flex-plots {*/
  /*    !*padding: 24px;*!*/
  /*  }*/

  /*}*/

  /*@media (min-width: 865px) {*/
  /*  .flex-plot-buffer {*/
  /*    width: 300px;*/
  /*    flex: 0 0 auto;*/
  /*    padding: 24px;*/
  /*    !*padding-left: 0;*!*/
  /*    !*padding-right: 24px;*!*/
  /*  }*/
  /*  .flex-plots {*/
  /*    !*max-width: 200px;*!*/
  /*    flex: 1 1 auto;*/
  /*    padding: 24px;*/
  /*  }*/

  /*  .state-plot {*/
  /*    height: 15px;*/
  /*  }*/
  /*  .line-plot {*/
  /*    height: 100px;*/
  /*  }*/

  /*}*/
</style>
